import { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import UserData from "../../../services/UserData";
import AIPreEnrichmentService from "../../../services/AIPreEnrichmentService";
import style from "./PreEnrichmentRuns.module.css";

import { label, DetailValue, DetailFields } from "./DetailFields";

const RunDetails = ({ runId, onClose }) => {
  const userData = useContext(UserData);
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);

  useEffect(() => {
    let active = true;
    setData(null);
    setError(false);
    if (!userData) return () => { active = false; };
    AIPreEnrichmentService.getRun(userData, runId)
      .then(result => { if (active) setData(result); })
      .catch(() => { if (active) setError(true); });
    return () => { active = false; };
  }, [userData, runId, retry]);

  return (
    <Modal show onHide={onClose} size="lg" scrollable aria-labelledby="run-details-title">
      <Modal.Header closeButton><Modal.Title id="run-details-title">Pre-Enrichment Run Details</Modal.Title></Modal.Header>
      <Modal.Body aria-busy={!data && !error}>
        {!data && !error && <p role="status">Loading run details…</p>}
        {error && <div role="alert">Unable to load run details. <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => setRetry(value => value + 1)}>Retry</button></div>}
        {data && <>
          <DetailFields data={Object.fromEntries(Object.entries(data).filter(([key]) => !["report", "progress", "request"].includes(key)))} />
          {["report", "progress", "request"].map(key => (
            <section key={key} aria-label={label(key)} className={style.detailSection}>
              <h3>{label(key)}</h3>
              <DetailValue value={data[key]} />
            </section>
          ))}
        </>}
      </Modal.Body>
      <Modal.Footer><button type="button" className="btn btn-secondary" onClick={onClose}>Close</button></Modal.Footer>
    </Modal>
  );
};

export default RunDetails;
